<template>
    <div>
        <!-- Loan Disbursement Info -->
        <div
            class="tw-bg-white tw-rounded-xl tw-shadow-lg tw-border tw-border-gray-100 tw-overflow-hidden"
            style="height: 36vh;"
        >
            <div
                class="tw-bg-gradient-to-r tw-from-green-900 tw-to-green-600 tw-px-4 tw-py-2"
            >
                <div
                    class="tw-text-md tw-font-semibold tw-text-white tw-flex tw-items-center tw-uppercase"
                >
                    <svg
                        class="tw-w-5 tw-h-5 tw-mr-2"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                    >
                        <path
                            d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"
                        />
                    </svg>
                    Loan Disbursement Info
                </div>
            </div>

            <div class="tw-p-4">
                <div
                    class="tw-grid tw-grid-cols-1 tw-md:tw-grid-cols-2 tw-gap-6"
                >
                    <div>
                        <div
                            class="tw-flex tw-justify-between tw-py-1 tw-border-b tw-border-gray-100"
                        >
                            <span class="tw-text-gray-600">{{
                                $t("loanRepayment.loanType")
                            }}</span>
                            <span class="tw-font-medium">{{
                                loan.loan_type
                                    ? loan.loan_type.loan_type_en
                                    : "-"
                            }}</span>
                        </div>
                        <div
                            class="tw-flex tw-justify-between tw-py-1 tw-border-b tw-border-gray-100"
                        >
                            <span class="tw-text-gray-600">{{
                                $t("loanRepayment.loanAmount")
                            }}</span>
                            <span class="tw-font-medium">{{
                                loan
                                    ? formatCurrencyWithCode(
                                          loan.loan_amount,
                                          currency
                                      )
                                    : "-"
                            }}</span>
                        </div>
                        <div
                            class="tw-flex tw-justify-between tw-py-1 tw-border-b tw-border-gray-100"
                        >
                            <span class="tw-text-gray-600">{{
                                $t("loanRepayment.interestRate")
                            }}</span>
                            <span class="tw-font-medium"
                                >{{ loan ? loan.interest_rate : "-" }}%</span
                            >
                        </div>
                        <div
                            class="tw-flex tw-justify-between tw-py-1 tw-border-b tw-border-gray-100"
                        >
                            <span class="tw-text-gray-600">{{
                                $t("loanRepayment.insuranceFee")
                            }}</span>
                            <span class="tw-font-medium">{{
                                loan
                                    ? formatCurrencyWithCode(
                                          loan.insurance_fee,
                                          currency
                                      )
                                    : ""
                            }}</span>
                        </div>
                        <div
                            class="tw-flex tw-justify-between tw-py-1 tw-border-b tw-border-gray-100"
                        >
                            <span class="tw-text-gray-600">{{
                                $t("loanRepayment.adminFee")
                            }}</span>
                            <span class="tw-font-medium">{{
                                loan
                                    ? formatCurrencyWithCode(
                                          loan.admin_fee,
                                          currency
                                      )
                                    : "-"
                            }}</span>
                        </div>
                    </div>

                    <div>
                        <div
                            class="tw-flex tw-justify-between tw-py-1 tw-border-b tw-border-gray-100"
                        >
                            <span class="tw-text-gray-600">{{
                                $t("loanRepayment.repaymentMethod")
                            }}</span>
                            <span class="tw-font-medium">{{
                                loan.repayment_method
                                    ? loan.repayment_method.method_name_en
                                    : "-"
                            }}</span>
                        </div>
                        <div
                            class="tw-flex tw-justify-between tw-py-1 tw-border-b tw-border-gray-100"
                        >
                            <span class="tw-text-gray-600">{{
                                $t("loanRepayment.firstInstallmentDate")
                            }}</span>
                            <span class="tw-font-medium">{{
                                loan ? loan.first_installment_date : "-"
                            }}</span>
                        </div>
                        <div
                            class="tw-flex tw-justify-between tw-py-1 tw-border-b tw-border-gray-100"
                        >
                            <span class="tw-text-gray-600">{{
                                $t("loanRepayment.skipSunday")
                            }}</span>
                            <span
                                class="tw-px-2 tw-py-1 tw-bg-gray-100 tw-text-gray-700 tw-text-xs tw-font-medium tw-rounded"
                                >{{ loan.is_skip_sunday ? "Yes" : "No" }}</span
                            >
                        </div>
                        <div
                            class="tw-flex tw-justify-between tw-py-1 tw-border-b tw-border-gray-100"
                        >
                            <span class="tw-text-gray-600">{{
                                $t("loanRepayment.allowPayOffOnCycle")
                            }}</span>
                            <span class="tw-font-medium">{{
                                loan ? loan.allow_pay_off_on_cycle : ""
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import { mapGetters, mapState } from "vuex";

export default {
    name: "loanInfo",
    props: ["value"],
    data() {
        return {
            model: {},
            errors: new Errors()
        };
    },
    created() {
        this.model = this.value;
    },
    computed: {
        ...mapState("creditOperation/loanRepayment", ["loanDisbursements"]),
        ...mapGetters(["formatCurrencyWithCode"]),
        loan() {
            if (this.loanDisbursements.length > 0 && this.model.loan_id) {
                return this.loanDisbursements.find(
                    l => l.loan_id == this.model.loan_id
                );
            }
            return [];
        },
        currency() {
            if (this.model.loan_id) {
                return this.loan.currency;
            }
            return {
                currency_id: this.$store.state.authUser.sys_setting[0]
                    .default_currency_id,
                currency_code: this.$store.state.authUser.sys_setting[0]
                    .default_currency
            };
        }
    }
};
</script>
